module.exports = __webpack_public_path__ + "static/media/medapps-logo-blue.ccabc1d8.png";